
import { defineComponent, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import useTooltip from '@/modern/composable/useTooltip'

export default defineComponent({
    props: {
        opened: {
            type: Boolean,
            default: true,
        }
    },
    setup(props) {
        const route = useRoute()
        const container = ref<HTMLElement | null>(null)

        const isOpened = ref(false)
        const isActive = ref(false)

        const { reference, tooltip, isVisible, x, y, strategy, open, close } = useTooltip({
            placement: 'right-end',
            strategy: 'absolute',
            offset: 12,
            autoPlacement: {
                allowedPlacements: ['right-end'],
            },
        })

        const onOpenTooltip = () => {
            if (!props.opened) {
                open()
            }
        }

        const checkCategoryActivity = () => {
            if (container.value) {
                const someActiveLink = container.value.querySelector('.router-link-exact-active')
                isActive.value = Boolean(someActiveLink)
            } else {
                isActive.value = false
            }
        }
        
        onMounted(checkCategoryActivity)

        watch(
            () => route.path,
            () => checkCategoryActivity
        )
        
        return {
            container,
            isOpened,
            isActive,
            reference,
            tooltip,
            isVisible,
            x,
            y,
            strategy,
            onOpenTooltip,
            close
        }
    }
})
